export default __webpack_public_path__ + "static/media/NocheDespejado.adbe73c8.svg";